import {colorsV2} from '@doltech/ui/lib/figma/colors-v2';
import {Answer} from '@doltech/ui/lib/figma/DesignSystemV2/components';
import {numberToABC} from '@doltech/utils/lib/text';
import cl from 'classnames';
import {observer} from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import {ExtraQuestionProps} from '../../components/questions/BaseQuestion';
import {getDragOutResult} from '../../components/questions/DragOutQuestionResult';
import {ResultDragOutQuestionInstance} from '../../model/Question/result-drag-out-question.store';
import {useTestResultStore} from '../../model/test-result.hook';
import {DragResultOptions, MOBILE_BOX_PADDING} from './DragInQuestionResultMobile';

interface DragOutResultMobileProps extends React.HTMLAttributes<HTMLDivElement> {
  data: ResultDragOutQuestionInstance & ExtraQuestionProps;
  isMobileView?: boolean;
}

export const scaleDraggingPoint = (originalImageSize, scaledImageSize, originalPointCoordinate) => {
  const percentWidth = (scaledImageSize || originalImageSize) / originalImageSize;
  return percentWidth * originalPointCoordinate;
};

export const DragOutQuestionResultMobile = observer((props: DragOutResultMobileProps) => {
  const { data, isMobileView, ...rest } = props;
  const { spots, image, marked, correctOptions, no, questions, index, userAnswers, scroll } = data;
  const store = useTestResultStore();
  const [scaledImageWidth, setScaledImageWidth] = React.useState(undefined);
  const [scaledImageHeight, setScaledImageHeight] = React.useState(undefined);

  const results = getDragOutResult({
    store,
    questions,
    marked,
    correctOptions,
    userAnswers,
    no,
    index,
    spots,
    scroll,
  });

  const imgElement = React.useRef(null);

  return (
    <MainMobile className="drag-out-answer" {...rest}>
      <ImageContainer>
        <Img
          loading="lazy"
          alt="Drag out result image"
          src={image.url}
          className="diagram-img"
          ref={imgElement}
          onLoad={() => {
            setScaledImageWidth(imgElement.current.clientWidth);
            setScaledImageHeight(imgElement.current.clientHeight);
          }}
        />
      </ImageContainer>
      {spots.map(({ x, y, id }, idx) => (
        <Spot
          style={{
            left: scaleDraggingPoint(image.width, scaledImageWidth, x) + MOBILE_BOX_PADDING,
            top: scaleDraggingPoint(image.height, scaledImageHeight, y) + MOBILE_BOX_PADDING,
          }}
          key={id}
        >
          <Answer
            className={cl({
              default: idx !== userAnswers[index],
              correct: idx === correctOptions[index].key,
              'in-correct': idx !== correctOptions[index].key && userAnswers[index] === idx,
            })}
          >
            {numberToABC(idx + 1)}
          </Answer>
        </Spot>
      ))}
      <DragResultOptions testMode={store.testMode} results={results} />
    </MainMobile>
  );
});

export const MainMobile = styled.div`
  box-sizing: border-box;
  box-shadow: 0 2px 2px ${colorsV2.blackShadow4};
  border-radius: 16px;
  position: relative;

  .no-focus {
    margin: 0;
  }
`;

export const ImageContainer = styled.div`
  background-color: ${colorsV2.white100};
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04), 0 0 2px rgba(0, 0, 0, 0.06),
    0 0 1px rgba(0, 0, 0, 0.04);
  padding: ${MOBILE_BOX_PADDING}px;

  .diagram-img {
    width: 100%;
    height: auto;
  }
`;



export const Img = styled.img``;

export const Spot = styled.span`
  position: absolute;
`;
